module.exports = __webpack_public_path__ + "static/media/ECI88_Slot.eba602e7.png";